<script>

import { testPlatformPlayer, platform } from '../page/troubleshooting.page.utils.mjs';

export default {
  translate25Context: 'troubleshooting',
  methods: {},
  props: ["handler", "instance"],
  data() {
    return {
      platform: {},
      checkPlatform: 'pending',
    };
  },
  methods: {

  },
  async mounted() {
    this.checkPlatform = await testPlatformPlayer() ? 'ok' : 'ko';

    this.platform = await platform();
  },
  watch: {}
};
</script>

<template>
  <div class="troubleshooting-speaker">
    <troubleshooting-page :title="$vt('Remote speaker prerequises')">
      <template #content>

        <div class="list">
          <div class="title">{{$vt('Domains')}}</div>

          <troubleshooting-page-http-status
            :component="instance['troubleshooting_speaker:api'].component.app"></troubleshooting-page-http-status>

          <troubleshooting-page-http-status
            :component="instance['troubleshooting_speaker:api'].component.vonage"></troubleshooting-page-http-status>

          <troubleshooting-page-websocket-status
            :component="instance['troubleshooting_speaker:api'].component.nodejs"></troubleshooting-page-websocket-status>

          <troubleshooting-page-http-status  :component="instance['troubleshooting_speaker:api'].component.vnginx.rtmp"></troubleshooting-page-http-status>

          <troubleshooting-page-http-status  :component="instance['troubleshooting_speaker:api'].component.vnginx.http"></troubleshooting-page-http-status>

          <span class="troubleshooting-speaker-wowzas"
            v-for="wowza in instance['troubleshooting_speaker:api'].component.wowzas" :key="wowza['#id']">

            <troubleshooting-page-http-status :component="wowza.http"></troubleshooting-page-http-status>
            
            <troubleshooting-page-webRTC-status :component="wowza.rtmp"></troubleshooting-page-webRTC-status>

          </span>

        </div>

        <div class="bandwith list">
          <div class="title">{{$vt('Network requirement')}}</div>
          <troubleshooting-bandwith
            :component="instance['troubleshooting_speaker:api'].component.bandwith"></troubleshooting-bandwith>
        </div>

        <div class="list">
          <div class="title">{{$vt('Browser')}}</div>
          <troubleshooting-page-platform></troubleshooting-page-platform>
        </div>

      </template>
    </troubleshooting-page>
  </div>
</template>

<style lang="scss">
.troubleshooting-speaker {
  width: 100%;
  height: 100%;
  overflow: auto;

  .troubleshooting-speaker-wowzas {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
}
</style>